import { render, staticRenderFns } from "./CaptainProfile.vue?vue&type=template&id=1792727b&scoped=true"
import script from "./CaptainProfile.vue?vue&type=script&lang=js"
export * from "./CaptainProfile.vue?vue&type=script&lang=js"
import style0 from "./CaptainProfile.vue?vue&type=style&index=0&id=1792727b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1792727b",
  null
  
)

export default component.exports